"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.discountableProductTypes = void 0;
const enums_1 = require("../enums");
exports.discountableProductTypes = [enums_1.ProductType.Box, enums_1.ProductType.Experience];
//# sourceMappingURL=ProductType.js.map